export default {
  data: {
    attrs: {
      showCancelBtn: false,
      cancelBtnLabel: 'overridden by props',
      finalStepLabel: 'also overridden',
      steps: Array,
      coursename: String,
      termname: String,
    }
  },
  methods: {
    nextClicked(i) {
      console.log('nextClicked, from view model');
    },
    previousClicked(i) {
      console.log('previousClicked, from view model');
    },
    completeClicked() {
      alert('complete clicked in vm');
      console.log('comleteClicked, from view model');
    },
    cancelClicked() {
      alert('cancel clicked in vm');
      console.log('cancelClicked, from view model');
    },
  },
  beforeMount() {
    console.log('beforeMount, from vm');
  },
  mounted() {
    console.log('mounted, from vm');
  },
};

